import { connect } from "react-redux";
import ShowAllDinMelPricesScreen from "./ShowAllDinMelPricesScreen";

export default connect((state) => {
  return {
    pricesDinMel: state.storehouse.pricesDinMel,
  };
})(ShowAllDinMelPricesScreen);
